var _ellipse, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilPicNexus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 384,
    viewBox: "0 0 377 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.082,
    cy: 192,
    rx: 188.082,
    ry: 192,
    fill: "#577590"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 194.655L58.6852 166.873L181.642 252.557V347.71L178.597 344.665L96.3846 256.364L49 194.655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.787 250.274L194.963 347.71V308.888L317.139 166.873L327.797 194.655L284.787 250.274Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6108 159.004L92.6977 37L141.907 135.193H182.046V217.058V312.756L92.6977 217.058L49.6108 159.004Z",
    fill: "#577590"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M327.861 159.004L284.774 37L235.565 135.193H195.426V217.058V312.756L284.774 217.058L327.861 159.004Z",
    fill: "#577590"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4834 251.754L49.3965 193.7L92.4834 71.6963L141.693 169.889H181.832V251.754M92.4834 251.754H181.832M92.4834 251.754L181.832 347.452V251.754M284.56 251.754L327.647 193.7L284.56 71.6963L235.35 169.889H195.212V251.754M284.56 251.754H195.212M284.56 251.754L195.212 347.452V251.754",
    stroke: "black",
    strokeWidth: 9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilPicNexus);
export default __webpack_public_path__ + "static/media/profil_pic-nexus.b045e5ad.svg";
export { ForwardRef as ReactComponent };